<template>
  <v-container fluid tag="section">
    <v-card class="rounded-lg elevation-0">
      <v-tabs v-model="tab" slider-color="primary">
        <v-tab>提成核算</v-tab>
        <!-- <v-tab>核算记录</v-tab> -->
      </v-tabs>
    </v-card>
    <div class="my-3">
      <v-tabs-items v-model="tab">
        <v-tab-item class="grey lighten-4">
          <check-view></check-view>
        </v-tab-item>
        <v-tab-item class="grey lighten-4">
          <history-view></history-view>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  import CheckView from './components/Check.vue'
  import HistoryView from './components/History.vue'

  export default {
    name: 'FinanceCommissionCheckIndex',
    components: {
      CheckView,
      HistoryView
    },
    data() {
      return {
        tab: 0
      }
    },
    methods: {
    }
  }
</script>
